"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractSlider = void 0;
var hammerjs_1 = __importDefault(require("hammerjs"));
var dom_interact_1 = require("../helpers/dom-interact");
var Views_1 = require("../Modules/Views");
var AbstractSlider = /** @class */ (function (_super) {
    __extends(AbstractSlider, _super);
    function AbstractSlider(el) {
        var _this = _super.call(this, el) || this;
        _this.events = [
            { name: 'click', queries: [AbstractSlider.PREV_BUTTON_SELECTOR], callback: _this.onPrevClick.bind(_this) },
            { name: 'click', queries: [AbstractSlider.NEXT_BUTTON_SELECTOR], callback: _this.onNextClick.bind(_this) },
        ];
        _this.customEvents = [];
        _this.bodyWidth = document.body.offsetWidth;
        _this.visibleSliderItems = 0; // reorder it as needs in your realisation
        _this.scrolledItems = 0;
        _this.activeSlideId = 0;
        _this.isAnimated = false;
        _this.totalItems = 0;
        _this.el = el;
        _this.frame = (0, dom_interact_1.getHTMLElement)(el, '.js-slider-frame');
        _this.slider = (0, dom_interact_1.getHTMLElement)(el, '.js-slider-tile');
        _this.isVertical = !!el.dataset.isVertical;
        var slideItemsNodeList = (0, dom_interact_1.getHTMLElements)(el, AbstractSlider.SLIDER_ITEMS_SELECTOR);
        _this.slideItems = Array.from(slideItemsNodeList);
        _this.hammer = new hammerjs_1.default(_this.slider);
        return _this;
    }
    AbstractSlider.prototype.init = function (config) {
        this.config = __assign({ duration: 400 }, config);
        this.totalItems = this.getTotalItems();
        this.setViewportSize();
        this.attachEvents();
    };
    AbstractSlider.prototype.attachEvents = function () {
        this.events = __spreadArray(__spreadArray([], this.events, true), this.customEvents, true);
        _super.prototype.attachEvents.call(this);
        window.addEventListener('resize', this.onResize.bind(this));
        this.hammer.on('swipeleft swiperight', this.handleSwipeEvents.bind(this));
    };
    /**
     ** Overwrite this method as needs
     * */
    AbstractSlider.prototype.setViewportSize = function () {
        return false;
    };
    AbstractSlider.prototype.handleSwipeEvents = function (e) {
        if (e.type === 'swiperight') {
            this.onPrevClick();
        }
        else if (e.type === 'swipeleft') {
            this.onNextClick();
        }
    };
    AbstractSlider.prototype.onResize = function () {
        var newWidth = document.body.offsetWidth;
        // resize needs only if width was changed. avoid resizing onScroll for tablets
        if (this.bodyWidth === newWidth) {
            return;
        }
        this.bodyWidth = newWidth;
        this.setViewportSize();
        if (this.isContentSmallerThanGallery()) {
            this.updateSliderPosition(0);
            return;
        }
        if (this.activeSlideId <= this.totalItems - this.visibleSliderItems) {
            this.scrolledItems = this.activeSlideId;
        }
        else {
            this.scrolledItems = this.totalItems - this.visibleSliderItems;
        }
        this.updateSliderPosition(this.sliderNextPosition);
    };
    AbstractSlider.prototype.goTo = function (position) {
        this.scrolledItems = position;
        this.animateGallery();
    };
    AbstractSlider.prototype.onPrevClick = function () {
        if (this.isAnimated) {
            return;
        }
        if (this.scrolledItems === 0) {
            this.activeSlideId = this.totalItems - 1;
            this.scrolledItems = this.totalItems - this.visibleSliderItems;
        }
        else {
            this.activeSlideId -= 1;
            this.scrolledItems -=
                this.scrolledItems >= this.visibleSliderItems ? this.visibleSliderItems : this.scrolledItems;
        }
        this.animateGallery();
    };
    AbstractSlider.prototype.onNextClick = function () {
        if (this.isAnimated) {
            return;
        }
        if (this.scrolledItems === this.totalItems - this.visibleSliderItems) {
            this.scrolledItems = 0;
            this.activeSlideId = 0;
        }
        else {
            this.activeSlideId += 1;
            if (this.scrolledItems + this.visibleSliderItems < this.totalItems - this.visibleSliderItems) {
                this.scrolledItems += this.visibleSliderItems;
            }
            else {
                this.scrolledItems = this.totalItems - this.visibleSliderItems;
            }
        }
        this.animateGallery();
    };
    AbstractSlider.prototype.animateGallery = function () {
        var _this = this;
        var start = performance.now();
        var prevSliderPosition = this.sliderPosition;
        var distanceToAnimate = prevSliderPosition + this.sliderNextPosition;
        this.isAnimated = true;
        var animate = function (time) {
            // timeFraction goes from 0 to 1
            var timeFraction = (time - start) / _this.config.duration;
            if (timeFraction > 1) {
                timeFraction = 1;
                _this.isAnimated = false;
            }
            // calculate the current animation state
            var progress = timeFraction * distanceToAnimate - prevSliderPosition;
            _this.updateSliderPosition(progress);
            if (timeFraction < 1) {
                requestAnimationFrame(animate);
            }
        };
        requestAnimationFrame(animate);
    };
    AbstractSlider.prototype.isContentSmallerThanGallery = function () {
        return this.sliderSize <= this.frameSize;
    };
    AbstractSlider.prototype.updateSliderPosition = function (value) {
        if (this.isVertical) {
            this.slider.style.top = "-".concat(value, "px");
            this.slider.style.left = '';
        }
        else {
            this.slider.style.left = "-".concat(value, "px");
            this.slider.style.top = '';
        }
    };
    Object.defineProperty(AbstractSlider.prototype, "tileSize", {
        get: function () {
            var firstSlideItem = this.slideItems[0];
            if (!firstSlideItem) {
                return 0;
            }
            return this.isVertical ? firstSlideItem.offsetHeight : firstSlideItem.offsetWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractSlider.prototype, "sliderSize", {
        get: function () {
            return this.tileSize * this.totalItems;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractSlider.prototype, "frameSize", {
        get: function () {
            return this.isVertical ? this.frame.offsetHeight : this.frame.offsetWidth;
        },
        set: function (value) {
            var propertyValue = value === 0 ? '' : "".concat(value, "px");
            if (this.isVertical) {
                this.frame.style.height = propertyValue;
                this.frame.style.width = '';
            }
            else {
                this.frame.style.width = propertyValue;
                this.frame.style.height = '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractSlider.prototype, "sliderPosition", {
        get: function () {
            return this.isVertical ? this.slider.offsetTop : this.slider.offsetLeft;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractSlider.prototype, "sliderNextPosition", {
        get: function () {
            var nextVisibleItem = this.slideItems[this.scrolledItems];
            if (!nextVisibleItem) {
                return 0;
            }
            return this.isVertical ? nextVisibleItem.offsetTop : nextVisibleItem.offsetLeft;
        },
        enumerable: false,
        configurable: true
    });
    AbstractSlider.prototype.getTotalItems = function () {
        return this.slideItems.length;
    };
    AbstractSlider.SLIDER_ITEMS_SELECTOR = '.js-slider-tile-item';
    AbstractSlider.NEXT_BUTTON_SELECTOR = '.js-next-btn';
    AbstractSlider.PREV_BUTTON_SELECTOR = '.js-prev-btn';
    return AbstractSlider;
}(Views_1.AbstractView));
exports.AbstractSlider = AbstractSlider;
exports.default = AbstractSlider;
